/* Copyright (c) 2020-present CloudIO Inc */

import { Box } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useTheme } from 'theme/Theme';
import './Loading.css';

export default function Loading({
  width = 300,
  height = 70,
}: {
  width?: string | number;
  height?: string | number;
}): React.ReactElement {
  const theme = useTheme();
  return (
    <Box
      sx={{ minWidth: width, minHeight: height, padding: 1 }}
      className={clsx('timeline-wrapper', theme.palette.mode)}
    >
      <Box
        sx={{ width, height }}
        className={clsx('timeline-item', theme.palette.mode)}
      >
        <Box
          sx={{ width, height }}
          className={clsx('animated-background', theme.palette.mode)}
        >
          <div className="background-masker content-top" />
          <div className="background-masker content-first-end" />
          <div className="background-masker content-second-line" />
          <div className="background-masker content-second-end" />
          <div className="background-masker content-third-line" />
          <div className="background-masker content-third-end" />
        </Box>
      </Box>
    </Box>
  );
}
